const _excluded = ["ref"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { useCallback, useEffect, useRef } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { GridItem, TextField } from 'seagull';
import { getOptionalAgreementNameValidation, getOptionalAgreementNameValidator } from "../../../business-logic/validators";
import { useOnMount } from "../../../hooks/useOnMount";
import { useTextFieldVariableIntegration } from "../TemplateVariables/hooks/useTextFieldVariableIntegration";
import { VariableFieldAdornment } from "../TemplateVariables/VariableFieldAdornment/VariableFieldAdornment";
import { VariablePickerPopover } from "../TemplateVariables/VariablePickerPopover/VariablePickerPopover";
import { VariablePreviewLine } from "../TemplateVariables/VariablePreviewLine/VariablePreviewLine";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const AGREEMENT_NAME_EXCLUDE_LABELS = ['Agreement Name'];
export function AgreementName(_ref) {
  let {
    agreementTitle,
    showWarning,
    setAgreementTitle,
    setAgreementTitleValid,
    label,
    disabled,
    testId,
    allowEmpty = false,
    fullWidth
  } = _ref;
  const {
    control,
    formState,
    watch,
    trigger,
    setValue
  } = useForm({
    mode: 'all',
    defaultValues: {
      agreementTitle
    }
  });
  const _inputRef = useRef(null);
  const watchedTitle = watch('agreementTitle');
  const setAgreementTitleField = useCallback(newValue => setValue('agreementTitle', newValue), [setValue]);
  const {
    enabled,
    inputProps,
    adornmentRef,
    adornmentStyle,
    fieldAdornmentProps,
    resolvedValues,
    pickerPopoverProps
  } = useTextFieldVariableIntegration(_inputRef, setAgreementTitleField, {
    disabled,
    excludeLabels: AGREEMENT_NAME_EXCLUDE_LABELS
  });
  useEffect(() => {
    return watch(data => {
      var _data$agreementTitle;
      setAgreementTitle((_data$agreementTitle = data.agreementTitle) !== null && _data$agreementTitle !== void 0 ? _data$agreementTitle : '');
    }).unsubscribe;
  }, [setAgreementTitle, watch]);
  useEffect(() => {
    setAgreementTitleValid(formState.isValid);
  }, [formState, setAgreementTitleValid]);
  useEffect(() => {
    if (showWarning) trigger('agreementTitle');
  }, [showWarning, trigger]);
  useOnMount(() => {
    trigger('agreementTitle');
  });
  const agreementNameValidation = getOptionalAgreementNameValidation(allowEmpty);
  const agreementNameValidator = getOptionalAgreementNameValidator(allowEmpty);
  const fieldElement = /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: "agreementTitle",
    rules: agreementNameValidation,
    render: _ref2 => {
      let {
        field: controllerField,
        fieldState: {
          isTouched,
          error
        }
      } = _ref2;
      const {
          ref: rhfRef
        } = controllerField,
        restField = _objectWithoutProperties(controllerField, _excluded);
      return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread(_objectSpread({
        collapseHelperText: true
      }, restField), {}, {
        ref: undefined,
        inputRef: el => {
          _inputRef.current = el;
          rhfRef(el);
        }
      }, agreementNameValidation.dataAttr || {}), {}, {
        label: label,
        disabled: disabled,
        testId: testId,
        placeholder: "The agreement name will help you identify this agreement",
        error: (showWarning || isTouched) && !!error,
        helperText: (showWarning || isTouched) && (error === null || error === void 0 ? void 0 : error.message),
        validateInBottomSheet: value => {
          const result = agreementNameValidator(value);
          return {
            error: result !== true,
            helperText: typeof result === 'string' ? result : undefined
          };
        },
        inputProps: inputProps,
        InputProps: enabled ? {
          endAdornment: /*#__PURE__*/_jsx("span", {
            ref: adornmentRef,
            style: adornmentStyle,
            children: /*#__PURE__*/_jsx(VariableFieldAdornment, _objectSpread({}, fieldAdornmentProps))
          })
        } : undefined
      }));
    }
  });
  return fullWidth ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(GridItem, {
      span: 12,
      children: [fieldElement, enabled && /*#__PURE__*/_jsx(VariablePreviewLine, {
        text: watchedTitle,
        resolvedValues: resolvedValues
      })]
    }), enabled && /*#__PURE__*/_jsx(VariablePickerPopover, _objectSpread({}, pickerPopoverProps))]
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(GridItem, {
      span: 9,
      children: [fieldElement, enabled && /*#__PURE__*/_jsx(VariablePreviewLine, {
        text: watchedTitle,
        resolvedValues: resolvedValues
      })]
    }), /*#__PURE__*/_jsx(GridItem, {
      span: 3
    }), enabled && /*#__PURE__*/_jsx(VariablePickerPopover, _objectSpread({}, pickerPopoverProps))]
  });
}